<template lang="pug">
with-actions(
  v-on="$listeners"
)
  .list.text-body-1
    p В разделе #[a(href="/documents" target="_blank").link "Документы"] добавьте общие правила&nbsp;
      | регистрации в системе и общие правила подачи заявки
    //- p В разделе #[a(href="/events/significance-coefficient" target="_blank").link "Мероприятия"]&nbsp;
    //-   | добавьте коэффициенты значимости.
    p В разделе #[a(href="/settings/appearance" target="_blank").link "Настройки"]&nbsp;
      | установите основные параметры:
      ul.list.list--gap-sm.text-body-1
        li логотип системы и ее наименование;
        //- li #[a(href="/settings/scores" target="_blank").link Начисление баллов];
        //- li #[a(href="/settings/significance-coefficient" target="_blank").link Коэффициенты значимости];
        li настройте документы для регистрации и записи в разделе&nbsp;
          | #[a(href="/settings/document-uses" target="_blank").link "Использование документов"];
        li прочитайте наши #[a(href="/instructions" target="_blank").link Инструкции].
</template>

<script>
import WithActions from '../components/WithActions.vue';

export default {
  name: 'OperatorWelcome',
  components: {
    WithActions,
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>
